
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageInit(e, page) {
      const app = this.$app;
      const $$ = this.$;
      var $page = $$(page.el);
      const pageId = page.route.context.pageId;
      const packageData = page.route.context.data.package;
      const maxPatients = parseInt(packageData.number_of_patients) || 1;
      let allPatients = [];
      let renewPatientIds = [];
      try {
        var stored = localStorage.getItem('renew_patient_ids');
        if (stored) {
          renewPatientIds = JSON.parse(stored);
          localStorage.removeItem('renew_patient_ids');
        }
      } catch (ex) {
      }
      function esc(s) {
        if (s === null || s === undefined)
          return '';
        return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }
      loadPatients();
      function loadPatients() {
        app.preloader.show();
        app.methods.authHeader();
        app.request({
          url: app.data.remoteUrl + 'patients',
          dataType: 'json',
          success: function (response) {
            app.preloader.hide();
            if (response.status && response.data) {
              allPatients = response.data;
            }
            if (renewPatientIds.length > 0) {
              renderPatients(renewPatientIds.map(String));
            } else {
              renderPatients();
            }
          },
          error: function () {
            app.preloader.hide();
            renderPatients();
          }
        });
      }
      function renderPatients(selectedIds) {
        if (!selectedIds) {
          selectedIds = [];
          $$('#' + pageId + ' input[name="patient_ids[]"]:checked').each(function () {
            selectedIds.push($$(this).val());
          });
        }
        var html = '';
        if (allPatients.length > 0) {
          allPatients.forEach(function (p) {
            var isChecked = selectedIds.indexOf(String(p.id)) > -1;
            html += '<label class="subs-patient-tile' + (isChecked ? ' is-checked' : '') + '">' + '<input type="checkbox" name="patient_ids[]" value="' + esc(p.id) + '"' + (isChecked ? ' checked' : '') + '>' + '<span class="subs-patient-tile-check">' + '<i class="icon f7-icons if-not-md">checkmark_alt</i>' + '<i class="icon material-icons md-only">check</i>' + '</span>' + '<span class="subs-patient-tile-body">' + '<span class="subs-patient-tile-name">' + esc(p.name) + '</span>' + '<span class="subs-patient-tile-meta">' + esc(p.gender) + ' &middot; ' + esc(p.age) + ' yrs</span>' + '</span>' + '</label>';
          });
        } else {
          html += '<div class="subs-empty-inline">No patients added yet. Add patients to continue.</div>';
        }
        $$('#' + pageId + ' #subscriptionPatientListArea').html(html);
        $$('#' + pageId + ' input[name="patient_ids[]"]').on('change', function () {
          var $tile = $$(this).closest('.subs-patient-tile');
          if (this.checked)
            $tile.addClass('is-checked');
          else
            $tile.removeClass('is-checked');
          updateCounter();
        });
        updateCounter();
      }
      function updateCounter() {
        var selectedCount = $$('#' + pageId + ' input[name="patient_ids[]"]:checked').length;
        var counterText = selectedCount + ' of ' + maxPatients;
        $$('#' + pageId + ' #patientCounter').text(counterText);
        var actionText = selectedCount === maxPatients ? maxPatients + ' / ' + maxPatients + ' selected' : selectedCount + ' / ' + maxPatients + ' selected';
        $$('#' + pageId + ' #subsActionCount').text(actionText);
        if (selectedCount === maxPatients) {
          $$('#' + pageId + ' #patientCounter').addClass('is-complete');
          $$('#' + pageId + ' #subsActionBar').addClass('is-ready');
          $$('#' + pageId + ' input[name="patient_ids[]"]:not(:checked)').prop('disabled', true);
        } else {
          $$('#' + pageId + ' #patientCounter').removeClass('is-complete');
          $$('#' + pageId + ' #subsActionBar').removeClass('is-ready');
          $$('#' + pageId + ' input[name="patient_ids[]"]').prop('disabled', false);
        }
      }
      $page.on('click', '.add-patient-btn', function (ev) {
        ev.preventDefault();
        app.popup.open('#subscriptionAddPatientPopup');
      });
      $$('#subscriptionSaveNewPatient').on('click', function () {
        var name = $$('#subscriptionNewPatientName').val().trim();
        var age = $$('#subscriptionNewPatientAge').val().trim();
        var gender = $$('input[name="subscription_new_patient_gender"]:checked').val();
        if (!name || !age) {
          app.dialog.alert('Please fill all patient details');
          return;
        }
        app.preloader.show();
        app.methods.authHeader();
        app.request({
          url: app.data.remoteUrl + 'patients',
          method: 'POST',
          data: {
            name: name,
            age: age,
            gender: gender
          },
          dataType: 'json',
          success: function (response) {
            app.preloader.hide();
            if (response.status) {
              var p = response.data;
              allPatients.push(p);
              app.popup.close('#subscriptionAddPatientPopup');
              $$('#subscriptionNewPatientName').val('');
              $$('#subscriptionNewPatientAge').val('');
              $$('input[name="subscription_new_patient_gender"][value="Male"]').prop('checked', true);
              var currentSelected = [];
              $$('#' + pageId + ' input[name="patient_ids[]"]:checked').each(function () {
                currentSelected.push($$(this).val());
              });
              if (currentSelected.length < maxPatients) {
                currentSelected.push(String(p.id));
              }
              renderPatients(currentSelected);
              app.toast.create({
                text: 'Patient added',
                closeTimeout: 1800,
                position: 'bottom'
              }).open();
            } else {
              var errorMsg = response.msg || 'Failed to add patient';
              if (response.errors) {
                var msgs = [];
                Object.keys(response.errors).forEach(function (k) {
                  msgs.push(response.errors[k].join(', '));
                });
                errorMsg = msgs.join('\n');
              }
              app.dialog.alert(errorMsg, 'Error');
            }
          },
          error: function (xhr) {
            app.preloader.hide();
            app.methods.requestError(xhr);
          }
        });
      });
      function submitBooking() {
        var selectedPatients = $$('#' + pageId + ' input[name="patient_ids[]"]:checked');
        if (selectedPatients.length === 0) {
          app.dialog.alert('Please select at least one patient');
          return;
        }
        if (selectedPatients.length > maxPatients) {
          app.dialog.alert('You can select maximum ' + maxPatients + ' patients for this plan');
          return;
        }
        var patientIds = [];
        selectedPatients.each(function () {
          patientIds.push($$(this).val());
        });
        var packageId = $$('#' + pageId + ' input[name="package_id"]').val();
        var couponCode = ($$('#' + pageId + ' input[name="coupon_code"]').val() || '').trim();
        var playerID = localStorage.getItem('playerID') || '';
        var params = 'package_id=' + encodeURIComponent(packageId);
        patientIds.forEach(function (id) {
          params += '&patient_ids[]=' + encodeURIComponent(id);
        });
        if (couponCode)
          params += '&coupon_code=' + encodeURIComponent(couponCode);
        if (playerID)
          params += '&one_signal_id=' + encodeURIComponent(playerID);
        app.methods.authHeader();
        app.preloader.show();
        app.request({
          url: app.data.remoteUrl + 'subscription-purchase',
          method: 'POST',
          data: params,
          dataType: 'json',
          success: function (returnData) {
            app.preloader.hide();
            if (returnData['status']) {
              var resData = returnData['data'];
              if (resData['requires_payment']) {
                paymentSubs(packageId);
              } else {
                app.dialog.alert(returnData['msg'] || 'Subscription activated successfully!', 'Success', function () {
                  app.views.main.router.navigate('/home/');
                  app.views.main.router.clearPreviousHistory();
                });
              }
            } else {
              app.dialog.alert(returnData['msg'] || 'Failed to process subscription');
            }
          },
          error: function (xhr) {
            app.preloader.hide();
            app.methods.requestError(xhr);
          }
        });
      }
      $$('#' + pageId + ' #subsPayBtn').on('click', function () {
        submitBooking();
      });
      $page.on('submit', '#subscriptionPayNow', function (ev) {
        ev.preventDefault();
        submitBooking();
      });
      function paymentSubs(pkgId) {
        app.methods.authHeader();
        app.preloader.show();
        app.request({
          url: app.data.remoteUrl + 'payments/initiate',
          method: 'POST',
          data: 'type=subscription&package_id=' + encodeURIComponent(pkgId),
          dataType: 'json',
          success: function (response) {
            app.preloader.hide();
            if (response.status && response.data) {
              response.data.description = 'mDOC Subscription';
              app.methods.razorpayCheckout(response.data, {
                onSuccess: function () {
                  app.dialog.alert('Payment successful! Your subscription is now active.', 'mDOC', function () {
                    app.views.main.router.navigate('/home/');
                    app.views.main.router.clearPreviousHistory();
                  });
                },
                onDismiss: function () {
                  app.dialog.alert('Payment processed. Please check your subscription status.', 'mDOC', function () {
                    app.views.main.router.navigate('/home/');
                    app.views.main.router.clearPreviousHistory();
                  });
                }
              });
            } else {
              app.dialog.alert(response.msg || 'Payment gateway URL not available');
            }
          },
          error: function () {
            app.preloader.hide();
            app.dialog.alert('Failed to initiate payment');
          }
        });
      }
    }
  },
  id: '7aef190184',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page subs-booking-page" data-name="subscription_booking_form" id="';
      r += c(ctx_1.pageId, ctx_1);
      r += '" data-ignore-cache="false"\n        removeElements=\'true\' router.off=\'on\'>\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">';
      r += c(ctx_1.data.package.name, ctx_1);
      r += '</div>\n            </div>\n        </div>\n        <div class="page-content">\n            <form id="subscriptionPayNow" class="subs-form">\n                <input type="hidden" name="package_id" value="';
      r += c(ctx_1.data.package.id, ctx_1);
      r += '">\n\n                <!-- Plan hero card -->\n                <div class="subs-plan-card">\n                    <div class="subs-plan-blob"></div>\n                    <div class="subs-plan-header">\n                        <div class="subs-plan-icon">\n                            <i class="icon f7-icons if-not-md">';
      r += Template7Helpers.js_if.call(ctx_1, 'this.data.package.number_of_patients > 1', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'person_2_fill';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += 'person_fill';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i>\n                            <i class="icon material-icons md-only">';
      r += Template7Helpers.js_if.call(ctx_1, 'this.data.package.number_of_patients > 1', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'group';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += 'person';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i>\n                        </div>\n                        <div class="subs-plan-title">\n                            <div class="subs-plan-name">';
      r += c(ctx_1.data.package.name, ctx_1);
      r += '</div>\n                            <div class="subs-plan-price">&#8377; ';
      r += c(ctx_1.data.order.amount, ctx_1);
      r += '</div>\n                        </div>\n                    </div>\n                    <div class="subs-plan-chips">\n                        <div class="subs-plan-chip">\n                            <i class="icon f7-icons if-not-md">calendar</i>\n                            <i class="icon material-icons md-only">event</i>\n                            <span>';
      r += c(ctx_1.data.package.validity_months, ctx_1);
      r += ' months</span>\n                        </div>\n                        <div class="subs-plan-chip">\n                            <i class="icon f7-icons if-not-md">person_2</i>\n                            <i class="icon material-icons md-only">people_outline</i>\n                            <span>';
      r += c(ctx_1.data.package.number_of_patients, ctx_1);
      r += ' members</span>\n                        </div>\n                        ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.data.package.total_opd > 0', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <div class="subs-plan-chip">\n                            <i class="icon f7-icons if-not-md">plus_app_fill</i>\n                            <i class="icon material-icons md-only">local_hospital</i>\n                            <span>';
          r += c(ctx_2.data.package.total_opd, ctx_2);
          r += ' free OPD</span>\n                        </div>\n                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    </div>\n                </div>\n\n                <!-- Patient selection -->\n                <section class="subs-section">\n                    <div class="subs-section-header">\n                        <span class="subs-section-title">Select patients</span>\n                        <span class="subs-section-counter" id="patientCounter">0 of ';
      r += c(ctx_1.data.package.number_of_patients, ctx_1);
      r += '</span>\n                    </div>\n                    <div class="subs-section-card">\n                        <div id="subscriptionPatientListArea">\n                            <!-- Patients will be dynamically loaded here -->\n                        </div>\n                        <a href="#" class="subs-add-patient-btn add-patient-btn">\n                            <i class="icon f7-icons if-not-md">plus_circle_fill</i>\n                            <i class="icon material-icons md-only">add_circle</i>\n                            <span>Add new patient</span>\n                        </a>\n                    </div>\n                </section>\n\n                <!-- Coupon code -->\n                <section class="subs-section">\n                    <div class="subs-section-header">\n                        <span class="subs-section-title">Coupon code</span>\n                        <span class="subs-section-optional">Optional</span>\n                    </div>\n                    <div class="subs-section-card subs-coupon-card">\n                        <div class="subs-coupon-row">\n                            <i class="icon f7-icons if-not-md subs-coupon-icon">tag</i>\n                            <i class="icon material-icons md-only subs-coupon-icon">local_offer</i>\n                            <input type="text" placeholder="Enter coupon code" name="coupon_code">\n                        </div>\n                    </div>\n                </section>\n\n                <div class="subs-bottom-spacer"></div>\n            </form>\n\n            <!-- Sticky bottom action bar -->\n            <div class="subs-action-bar" id="subsActionBar">\n                <div class="subs-action-summary">\n                    <div class="subs-action-count" id="subsActionCount">0 / ';
      r += c(ctx_1.data.package.number_of_patients, ctx_1);
      r += ' selected</div>\n                    <div class="subs-action-total">&#8377;';
      r += c(ctx_1.data.order.amount, ctx_1);
      r += '</div>\n                </div>\n                <button type="button" class="subs-action-btn" id="subsPayBtn">\n                    <span>Pay now</span>\n                    <i class="icon f7-icons if-not-md">arrow_right</i>\n                    <i class="icon material-icons md-only">arrow_forward</i>\n                </button>\n            </div>\n        </div>\n\n        <!-- Add New Patient Popup -->\n        <div class="popup subs-add-patient-popup" id="subscriptionAddPatientPopup">\n            <div class="view">\n                <div class="page">\n                    <div class="navbar">\n                        <div class="navbar-inner">\n                            <div class="left">\n                                <a href="#" class="link popup-close" aria-label="Close">\n                                    <i class="icon icon-back"></i>\n                                </a>\n                            </div>\n                            <div class="title">Add New Patient</div>\n                        </div>\n                    </div>\n                    <div class="page-content">\n                        <div class="pl-popup-intro">\n                            <div class="pl-popup-intro-title">Patient details</div>\n                            <div class="pl-popup-intro-sub">This patient will be available for all future bookings.</div>\n                        </div>\n                        <div class="pl-form">\n                            <div class="pl-form-field">\n                                <label class="pl-form-label" for="subscriptionNewPatientName">\n                                    <span>Name</span>\n                                    <span class="pl-form-required">*</span>\n                                </label>\n                                <input type="text" id="subscriptionNewPatientName" placeholder="Patient name">\n                            </div>\n                            <div class="pl-form-field">\n                                <label class="pl-form-label" for="subscriptionNewPatientAge">\n                                    <span>Age</span>\n                                    <span class="pl-form-required">*</span>\n                                </label>\n                                <input type="number" id="subscriptionNewPatientAge" placeholder="Age in years" pattern="[0-9]*" inputmode="numeric">\n                            </div>\n                            <div class="pl-form-field">\n                                <span class="pl-form-label">\n                                    <span>Gender</span>\n                                    <span class="pl-form-required">*</span>\n                                </span>\n                                <div class="pl-gender-row">\n                                    <label class="pl-gender-pill">\n                                        <input type="radio" checked="" name="subscription_new_patient_gender" value="Male">\n                                        <span>Male</span>\n                                    </label>\n                                    <label class="pl-gender-pill">\n                                        <input type="radio" name="subscription_new_patient_gender" value="Female">\n                                        <span>Female</span>\n                                    </label>\n                                    <label class="pl-gender-pill">\n                                        <input type="radio" name="subscription_new_patient_gender" value="Other">\n                                        <span>Other</span>\n                                    </label>\n                                </div>\n                            </div>\n                            <button class="pl-popup-save-btn" type="button" id="subscriptionSaveNewPatient">Save patient</button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  style: `
[data-f7-7aef190184] .subs-booking-page { background: var(--mdoc-bg); }
[data-f7-7aef190184] .subs-booking-page .page-content { background: var(--mdoc-bg); padding-bottom: 24px; }
[data-f7-7aef190184] .subs-form { padding: 14px 14px 0; }

    /* Plan hero — pastel green-soft → blue-soft (matches home + details) */
[data-f7-7aef190184] .subs-plan-card {
        position: relative;
        background: linear-gradient(160deg, var(--mdoc-green-soft) 0%, var(--mdoc-blue-soft) 100%);
        border: 1px solid rgba(46, 182, 125, 0.18);
        border-radius: 18px;
        padding: 0;
        overflow: hidden;
        margin-bottom: 16px;
    }
[data-f7-7aef190184] .subs-plan-blob {
        position: absolute;
        top: -30px;
        right: -30px;
        width: 130px;
        height: 130px;
        background: radial-gradient(circle, rgba(255,255,255,0.55) 0%, rgba(255,255,255,0) 70%);
        border-radius: 50%;
        pointer-events: none;
    }
[data-f7-7aef190184] .subs-plan-header {
        position: relative;
        z-index: 1;
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 16px 16px 12px;
    }
[data-f7-7aef190184] .subs-plan-icon {
        width: 48px;
        height: 48px;
        border-radius: 14px;
        background: var(--mdoc-white);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        box-shadow: 0 2px 8px rgba(15, 31, 46, 0.08);
    }
[data-f7-7aef190184] .subs-plan-icon .icon {
        font-size: 24px;
        color: var(--mdoc-green-dark);
    }
[data-f7-7aef190184] .subs-plan-title { flex: 1; min-width: 0; }
[data-f7-7aef190184] .subs-plan-name {
        font-size: 16px;
        font-weight: 700;
        color: var(--mdoc-ink);
        line-height: 1.2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
[data-f7-7aef190184] .subs-plan-price {
        font-size: 22px;
        font-weight: 800;
        color: var(--mdoc-green-dark);
        margin-top: 2px;
        letter-spacing: -0.4px;
    }
[data-f7-7aef190184] .subs-plan-chips {
        position: relative;
        z-index: 1;
        display: flex;
        gap: 8px;
        padding: 0 12px 14px;
        flex-wrap: wrap;
    }
[data-f7-7aef190184] .subs-plan-chip {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 5px 10px;
        background: var(--mdoc-white);
        border-radius: 100px;
        font-size: 11.5px;
        font-weight: 700;
        color: var(--mdoc-green-dark);
        box-shadow: 0 1px 3px rgba(15, 31, 46, 0.04);
    }
[data-f7-7aef190184] .subs-plan-chip .icon {
        font-size: 13px;
        color: var(--mdoc-green-dark);
    }
[data-f7-7aef190184] .subs-plan-chip:nth-child(2) { color: var(--mdoc-blue-dark); }
[data-f7-7aef190184] .subs-plan-chip:nth-child(2) .icon { color: var(--mdoc-blue-dark); }
[data-f7-7aef190184] .subs-plan-chip:nth-child(3) { color: #C2570A; }
[data-f7-7aef190184] .subs-plan-chip:nth-child(3) .icon { color: #C2570A; }

    /* Sections */
[data-f7-7aef190184] .subs-section { margin-bottom: 16px; }
[data-f7-7aef190184] .subs-section-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 4px 8px;
    }
[data-f7-7aef190184] .subs-section-title {
        font-size: 13px;
        font-weight: 700;
        color: var(--mdoc-ink);
        letter-spacing: -0.1px;
    }
[data-f7-7aef190184] .subs-section-counter {
        font-size: 11px;
        font-weight: 700;
        color: var(--mdoc-green-dark);
        background: var(--mdoc-green-soft);
        padding: 3px 10px;
        border-radius: 100px;
        transition: background .15s ease, color .15s ease;
    }
[data-f7-7aef190184] .subs-section-counter.is-complete {
        background: var(--mdoc-green);
        color: var(--mdoc-white);
    }
[data-f7-7aef190184] .subs-section-optional {
        font-size: 11px;
        font-weight: 600;
        color: var(--mdoc-muted);
    }
[data-f7-7aef190184] .subs-section-card {
        background: var(--mdoc-white);
        border: 1px solid var(--mdoc-border);
        border-radius: 14px;
        padding: 4px 12px;
    }

    /* Patient tiles */
[data-f7-7aef190184] .subs-patient-tile {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 8px;
        margin: 0 -8px;
        border-bottom: 1px solid var(--mdoc-border);
        cursor: pointer;
        border-radius: 8px;
        transition: background .15s ease;
        padding-left: 8px;
        padding-right: 8px;
    }
[data-f7-7aef190184] .subs-patient-tile:last-of-type { border-bottom: none; }
[data-f7-7aef190184] .subs-patient-tile.is-checked { background: var(--mdoc-green-soft); }
[data-f7-7aef190184] .subs-patient-tile input[type="checkbox"] {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
        pointer-events: none;
    }
[data-f7-7aef190184] .subs-patient-tile-check {
        width: 22px;
        height: 22px;
        border-radius: 6px;
        border: 2px solid var(--mdoc-border);
        background: var(--mdoc-white);
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: border-color .15s ease, background .15s ease;
    }
[data-f7-7aef190184] .subs-patient-tile-check .icon {
        color: var(--mdoc-white);
        font-size: 16px;
        opacity: 0;
        transform: scale(0.6);
        transition: opacity .15s ease, transform .15s ease;
    }
[data-f7-7aef190184] .subs-patient-tile input[type="checkbox"]:checked + .subs-patient-tile-check {
        background: var(--mdoc-green);
        border-color: var(--mdoc-green);
    }
[data-f7-7aef190184] .subs-patient-tile input[type="checkbox"]:checked + .subs-patient-tile-check .icon {
        opacity: 1;
        transform: scale(1);
    }
[data-f7-7aef190184] .subs-patient-tile input[type="checkbox"]:disabled + .subs-patient-tile-check {
        opacity: 0.4;
        border-color: var(--mdoc-border);
    }
[data-f7-7aef190184] .subs-patient-tile-body { flex: 1; min-width: 0; }
[data-f7-7aef190184] .subs-patient-tile-name {
        font-size: 14px;
        font-weight: 700;
        color: var(--mdoc-ink);
        line-height: 1.2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
[data-f7-7aef190184] .subs-patient-tile-meta {
        font-size: 12px;
        color: var(--mdoc-muted);
        margin-top: 3px;
    }

[data-f7-7aef190184] .subs-empty-inline {
        font-size: 13px;
        color: var(--mdoc-muted);
        text-align: center;
        padding: 14px 0;
    }
[data-f7-7aef190184] .subs-add-patient-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 12px 0;
        margin: 4px 0 6px;
        border-top: 1px dashed var(--mdoc-border);
        text-decoration: none;
        color: var(--mdoc-green-dark);
        font-size: 13px;
        font-weight: 700;
    }
[data-f7-7aef190184] .subs-add-patient-btn .icon {
        color: var(--mdoc-green);
        font-size: 18px;
    }

    /* Coupon row */
[data-f7-7aef190184] .subs-coupon-card { padding: 4px 12px; }
[data-f7-7aef190184] .subs-coupon-row {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 8px 0;
    }
[data-f7-7aef190184] .subs-coupon-icon {
        font-size: 18px;
        color: var(--mdoc-green-dark);
        flex-shrink: 0;
    }
[data-f7-7aef190184] .subs-coupon-row input {
        flex: 1;
        min-width: 0;
        border: none;
        background: transparent;
        font-size: 14px;
        color: var(--mdoc-ink);
        outline: none;
        padding: 8px 0;
    }
[data-f7-7aef190184] .subs-coupon-row input::placeholder { color: var(--mdoc-muted); }

    /* Sticky bottom action bar */
[data-f7-7aef190184] .subs-bottom-spacer { height: 88px; }
[data-f7-7aef190184] .subs-action-bar {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 14px calc(12px + env(safe-area-inset-bottom));
        background: var(--mdoc-white);
        border-top: 1px solid var(--mdoc-border);
        box-shadow: 0 -4px 14px rgba(15, 31, 46, 0.06);
        z-index: 50;
    }
[data-f7-7aef190184] .subs-action-summary {
        flex: 1 1 auto;
        min-width: 0;
        overflow: hidden;
    }
[data-f7-7aef190184] .subs-action-count {
        font-size: 11px;
        font-weight: 600;
        color: var(--mdoc-muted);
        letter-spacing: 0.2px;
        line-height: 1.1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
[data-f7-7aef190184] .subs-action-total {
        font-size: 18px;
        font-weight: 800;
        color: var(--mdoc-ink);
        letter-spacing: -0.4px;
        margin-top: 2px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
[data-f7-7aef190184] .subs-action-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        padding: 0 16px;
        height: 42px;
        flex: 0 0 auto;
        background: var(--mdoc-border);
        color: var(--mdoc-muted);
        border: none;
        border-radius: 100px;
        font-size: 13.5px;
        font-weight: 700;
        cursor: not-allowed;
        transition: background .15s ease, color .15s ease, transform .15s ease;
        box-shadow: none;
        white-space: nowrap;
    }
[data-f7-7aef190184] .subs-action-btn .icon {
        font-size: 15px;
        color: inherit;
    }
[data-f7-7aef190184] .subs-action-bar.is-ready .subs-action-btn {
        background: var(--mdoc-green);
        color: var(--mdoc-white);
        cursor: pointer;
        box-shadow: 0 4px 12px rgba(46, 182, 125, 0.25);
    }
[data-f7-7aef190184] .subs-action-bar.is-ready .subs-action-btn:active {
        background: var(--mdoc-green-dark);
        transform: scale(0.97);
    }
`,
  styleScoped: true
};
    